import { IVariableScope } from "@@expressions";

/**
 * Static cache mapping keyPath strings to their split arrays
 */
const keyPathCache = new Map<string, string[]>();

/**
 * Gets or creates a split keyPath array from cache
 */
function getSplitKeyPath(keyPath: string): string[] {
  let splitPath = keyPathCache.get(keyPath);
  if (!splitPath) {
    splitPath = keyPath.split(".");
    keyPathCache.set(keyPath, splitPath);
  }
  return splitPath;
}

/**
 * Checks if an object is an IVariableScope
 */
function isVariableScope(obj: any): obj is IVariableScope {
  return obj && typeof obj.tryGet === "function";
}

export default function getNestedPropertyValue(keyPath: string, obj: Record<string, any> | IVariableScope): any {
  const splitPath = getSplitKeyPath(keyPath);

  // Fast path for simple property access without nesting
  if (splitPath.length === 1) {
    const key = splitPath[0];
    if (isVariableScope(obj)) {
      return obj.tryGet(key);
    }
    return obj && obj[key] !== undefined ? obj[key] : undefined;
  }

  return splitPath.reduce((o, k) => {
    if (!o) return undefined;
    if (isVariableScope(o)) {
      return o.tryGet(k);
    }
    return o[k] !== undefined ? o[k] : undefined;
  }, obj as any);
}
